import axios from "axios";
import AttributeModel from '../../../models/AttributeModel';
import { urlBaseAccreditationMice } from './../../config/index';

export default async function getAttributesListApi(
  token = '',
  eventId = '',
) {
  try {
    const _config = {
      url: `${urlBaseAccreditationMice}/mice/events/${eventId}/fields`,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `bearer ${token}`
      },
    };

    let _data = await axios(_config);

    let _return = [];
    _data.data.forEach((item) => {
      _return.push(AttributeModel({
        ID: item.id.toString(),
        EventoID: eventId,
        Nome: item.name,
        DbReferencia: item.reference
      }));
    });

    return _return;
  } catch (error) {
    console.log('Error getAttributesListApi', error);
    throw error;
  }
}
